import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../../Shared/Loader';
import { useRef } from 'react';
import AddSalesProductList from './AddSalesProductList';
import AddSalesInvoice from './AddSalesInvoice';
import { selectCustomer } from '../../../../features/SalesSlice/SalesSlice';
import { format } from 'date-fns';
import useFetchData from '../../../../hooks/useFetchData';
import CustomerList from '../../../../hooks/CustomerList';
import person from '../../../../assets/images/person.jpeg'
import ImageModal from '../../../Shared/ImageModal';
import { nextTenantNumber, useTenantNumbering } from '../../../../saas/tenantNumbering';
import { Link, useLocation } from 'react-router-dom';
import { FiArrowLeft, FiCalendar, FiShoppingBag, FiUser } from 'react-icons/fi';
import '../AddPosSales/AddPosSalesMobile.css';



const AddBikeSales = ({ }) => {
    const legacySetting = useSelector((state) => state.info.settings);
    const tenantNumbering = useTenantNumbering();
    const setting = { ...(legacySetting || {}), ...tenantNumbering };
    const { posCustomer, isCustomer } = useSelector((state) => state.salesInvoice);
    const { items } = useFetchData('https://servers.thakurgaonexpress.com/rupkotha/getsalesinvoice');
    const [isSearching, setIsSearching] = useState(false);
    const [searchResult, setSearchResult] = useState([]);
    const [searchText, setSearchText] = useState([]);
    const [loading, setLoading] = useState(true);
    const [customers, setCustomers] = useState([]);
    const [currentCustomer, setCurrentCustomer] = useState([]);
    const [details, setDetails] = useState();
    const [isInvoice, setIsInvoice] = useState(false);
    // const [isCustomer, setIsCustomer] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const date = new Date();
    const today = format(date, "yyyy-MM-dd");
    const [invoiceNo, setInvoiceNo] = useState('');

    console.log(isCustomer);

    const customerCodeRef = useRef('');
    const customerRef = useRef('');
    const addressRef = useRef('');
    const phoneRef = useRef('');
    const openingRef = useRef('');
    const dateRef = useRef('');
    const dispatch = useDispatch();
    const location = useLocation();
    const isMobileTransactionEditor = location.pathname === '/mobile/adddefaultsales';



    useEffect(() => {
        fetch('https://servers.thakurgaonexpress.com/rupkotha/getmaincustomers')
            .then(res => res.json())
            .then(data => {
                setCustomers(data);
                setLoading(false)
            })
    }, [])
  

    useEffect(() => {
        const myLength = nextTenantNumber(setting.Sales_Invoice_Prefix, items.length);
        const isExist = items?.filter(memo => memo?.salesInvoice === myLength);
        const duplicate = isExist?.length ? true : false;

        if (duplicate) {
            // Increment the suffix to avoid duplicates
            const suffix = isExist.length + 1;
            setInvoiceNo(`${myLength}-${suffix}`);
        } else {
            setInvoiceNo(myLength);
        }
    }, [items, setting.Sales_Invoice_Prefix]);


    if (loading) {
        return <Loader />
    }

    const handleSearchResult = (event) => {
        setSearchText(event.target.value)
        const match = customers.filter(customer => customer.name.includes(searchText)
            || customer.name.toLowerCase().includes(searchText) ||
            customer.name.toUpperCase().includes(searchText));
        setSearchResult(match);
        setIsSearching(true);
    }

    const handleSelectCustomer = (customer) => {
        const opening = parseFloat(customer?.opening)
        const url = `https://servers.thakurgaonexpress.com/rupkotha/filteredmaincustomer?code=${customer?.code}`
        fetch(url)
            .then(res => res.json())
            .then(data => {
                console.log(data);
                const due = opening + data?.defaultTotalDue - data?.defaultTotalCollect;
                setCurrentCustomer({ ...customer, due });
            })
        setIsSearching(false)
        setSearchText('');
        // setIsCustomer(true);
    }

    // Menuel Memo Entry
    const handleSalesDetails = (event) => {
        const salesInvoice = event?.target?.value;
        const customerCode = customerCodeRef?.current?.innerText;
        const salesCustomer = customerRef?.current?.innerText;
        const salesAddress = addressRef?.current?.innerText;
        const salesPhone = phoneRef?.current?.innerText;
        const salesOpening = parseFloat(openingRef?.current?.innerText);
        const salesDate = dateRef?.current?.value;
        const isExist = items?.filter(memo => memo?.salesInvoice === salesInvoice);
        const duplicate = isExist?.length ? true : false;

        const updatedDetails = { salesInvoice: setting?.Auto_Sales_Invoice ? invoiceNo : salesInvoice, customerCode, salesCustomer, salesAddress, salesPhone, salesOpening, salesDate, duplicate, img: posCustomer?.img }
        if (!setting?.Auto_Sales_Invoice) {
            updatedDetails.isExit = true;
            updatedDetails.duplicate = duplicate;
        }
        setIsInvoice(true);
        setDetails(updatedDetails)

    
    }


    if (isMobileTransactionEditor) {
        return <div className="mobile-sale-checkout mobile-default-sale-checkout">
            <header className="mobile-sale-checkout__hero"><div><p className="mobile-sale-checkout__eyebrow"><FiShoppingBag />Touch sales checkout</p><h1>New default sale</h1><p>Invoice {invoiceNo || '—'}</p></div><Link className="mobile-sale-checkout__home" to="/mobile" aria-label="Return to mobile dashboard"><FiArrowLeft /></Link></header>
            <section className="mobile-sale-checkout__section"><div className="mobile-sale-checkout__section-head"><h2><FiUser />Customer</h2><small>Tap to search</small></div><div className="mobile-sale-checkout__customer-picker"><CustomerList handleSalesDetails={handleSalesDetails} customers={customers} /></div><div className="mobile-sale-checkout__customer-summary"><div className="mobile-sale-checkout__customer-card"><small>Selected customer</small><strong ref={customerRef}>{posCustomer?.name || 'Walking customer'}</strong><span><span ref={customerCodeRef}>{posCustomer?.code || '—'}</span> · <span ref={phoneRef}>{posCustomer?.phone || 'No phone'}</span></span><span ref={addressRef} className="hidden">{posCustomer?.address || 'N/A'}</span></div><div className="mobile-sale-checkout__due-card"><small>Previous due</small><strong ref={openingRef}>{Number(posCustomer?.due || 0).toFixed(2)}</strong></div></div></section>
            <section className="mobile-sale-checkout__section"><div className="mobile-sale-checkout__section-head"><h2><FiCalendar />Sale details</h2><small>Complete invoice setup</small></div><div className="mobile-sale-checkout__meta-grid"><div className="mobile-sale-checkout__field"><label>Sale date</label><input ref={dateRef} defaultValue={today} type="date" /></div><div className="mobile-sale-checkout__field"><label>Invoice number</label><input disabled={setting?.Auto_Sales_Invoice ? !isCustomer : ''} onChange={handleSalesDetails} {...(setting?.Auto_Sales_Invoice ? { value: invoiceNo, readOnly: true } : { defaultValue: '' })} type="text" placeholder="Invoice number" /></div></div>{details?.duplicate && <p className="mobile-sale-checkout__warning">This invoice number already exists. Change it before continuing.</p>}</section>
            <section className="mobile-sale-checkout__section mobile-default-sale-checkout__products"><div className="mobile-sale-checkout__section-head"><h2>Product & cart</h2><small>Search then add items</small></div><AddSalesProductList handleSalesDetails={setting?.Auto_Sales_Invoice && handleSalesDetails} isCustomer={setting?.Auto_Sales_Invoice && isCustomer} /><AddSalesInvoice details={details} isInvoice={isInvoice} isCustomer={isCustomer} /></section>
        </div>;
    }

    return (
        <div className={`tenant-page text-xs${isMobileTransactionEditor ? ' mobile-default-editor' : ''}`}>
            <h1 className='tenant-page__heading tenant-page__heading--single'>Add A Sales</h1>
            <div className='transaction-panel grid grid-cols-1 lg:grid-cols-12 gap-4 mt-4'>
                <div class="form-control w-full lg:w-60 max-w-xs mt-5 col-span-2">
                    <div class="form-control lg:w-60 mx-auto">
                        <CustomerList handleSalesDetails={handleSalesDetails} customers={customers} />
                    </div>
                </div>
                <div className='lg:col-span-6 mt-4 overflow-auto lg:overflow-visible'>
                    <table class="table lg:w-1/2 lg:ml-32">
                        <thead className='text-center'>
                            <tr>
                                <th className='bg-primary text-white normal-case'>Image</th>
                                <th className='bg-primary text-white normal-case'>Customer Code</th>
                                <th className='bg-primary text-white normal-case'>Customer Name</th>
                                <th className='bg-primary text-white normal-case'>Customer Address</th>
                                <th className='bg-primary text-white normal-case'>Mobile No</th>
                                <th className='bg-primary text-white normal-case'>Previews Due</th>
                            </tr>
                        </thead>
                        <tbody className='text-center'>
                            <tr className=''>
                                <td className='h-8'><label className='cursor-pointer' for="image-modal"
                                    onClick={() => setSelectedImage(posCustomer?.img ? posCustomer?.img : person)}>
                                    <img src={posCustomer?.img ? posCustomer?.img : person} alt="" /></label></td>
                                <td ref={customerCodeRef} className='h-8'>{posCustomer?.code}</td>
                                <td ref={customerRef} className='h-8'>{posCustomer?.name}</td>
                                <td ref={addressRef}>{posCustomer?.address}</td>
                                <td ref={phoneRef}>{posCustomer?.phone}</td>
                                <td ref={openingRef}>{(posCustomer?.due)?.toFixed(2)}</td>
                            </tr>

                        </tbody>
                    </table>
                </div>
                <br />
                <div className='lg:col-span-4 mt-4'>
                    <table class="table w-1/2 mx-auto">
                        <thead className='text-center'>
                            <tr>
                                <th className='bg-primary text-white normal-case'>Select Date</th>
                                <th className='bg-primary text-white normal-case'>Invoice No</th>
                            </tr>
                        </thead>
                        <tbody className='text-center'>
                            <tr className=''>
                                <td><input ref={dateRef} defaultValue={today} type="date" className='rounded-lg bg-gray-200 p-3  text-center placeholder-gray-400 focus:border-blue-500 focus:bg-white focus:outline-none w-full max-w-xs' /></td>
                                <td><input disabled={setting?.Auto_Sales_Invoice ? !isCustomer : ''} onChange={handleSalesDetails} {...(setting?.Auto_Sales_Invoice ? { value: invoiceNo } : { defaultValue: '' })} type="text" placeholder='Type Invoice' className='rounded-lg bg-gray-200 p-3 w-40 text-center placeholder-gray-400 focus:border-blue-500 focus:bg-white focus:outline-none w-full max-w-xs' /></td>
                            </tr>
                            {details?.duplicate && <tr className=''>
                                <td></td>
                                <td className='text-primary font-bold'>(Duplicate Please Change)</td>
                            </tr>}
                        </tbody>
                    </table>
                </div>
            </div>
            <div className='grid grid-cols-1 relative'>
                <AddSalesProductList handleSalesDetails={setting?.Auto_Sales_Invoice && handleSalesDetails} isCustomer={setting?.Auto_Sales_Invoice && isCustomer} />
                <AddSalesInvoice details={details} isInvoice={isInvoice} isCustomer={isCustomer} />
            </div>
            {selectedImage && (
                <ImageModal selectedImage={selectedImage} setSelectedImage={setSelectedImage} />
            )}
        </div>
    );
};

export default AddBikeSales;
